import BaseStore from "@/v1/utils/BaseStore";

import {
  GET_CASINO_COLLECTIONS_EXECUTIONS_START,
  GET_CASINO_COLLECTIONS_EXECUTIONS_SUCCESS,
} from "./types";

const initialState = {
  loading: false,
  results: [],
};

const store = new BaseStore("casinoCollectionExecutions", initialState);

const reducer = {
  [GET_CASINO_COLLECTIONS_EXECUTIONS_START]: state => ({
    ...state,
    loading: true,
  }),
  [GET_CASINO_COLLECTIONS_EXECUTIONS_SUCCESS]: (state, payload) => ({
    ...state,
    results: payload.results,
    page: payload.page,
    loading: false,
  }),
};

export default store.reducer(reducer);
